/* Hallmark · pre-emit critique: P5 H5 E5 S5 R5 V5 */
@font-face {
  font-family: "Space Grotesk Variable";
  src: url("./node_modules/@fontsource-variable/space-grotesk/files/space-grotesk-latin-wght-normal.woff2") format("woff2-variations");
  font-style: normal;
  font-weight: 300 700;
  font-display: swap;
}

@font-face {
  font-family: "Inter Variable";
  src: url("./node_modules/@fontsource-variable/inter/files/inter-latin-wght-normal.woff2") format("woff2-variations");
  font-style: normal;
  font-weight: 100 900;
  font-display: swap;
}

@font-face {
  font-family: "JetBrains Mono Variable";
  src: url("./node_modules/@fontsource-variable/jetbrains-mono/files/jetbrains-mono-latin-wght-normal.woff2") format("woff2-variations");
  font-style: normal;
  font-weight: 100 800;
  font-display: swap;
}

:root {
  --color-paper: oklch(98.5% 0.004 250);
  --color-paper-2: oklch(96% 0.008 250);
  --color-paper-3: oklch(92.5% 0.012 250);
  --color-ink: oklch(20% 0.02 258);
  --color-ink-2: oklch(29% 0.02 258);
  --color-body: oklch(36% 0.018 257);
  --color-muted: oklch(48% 0.018 255);
  --color-rule: oklch(87% 0.014 250);
  --color-rule-2: oklch(76% 0.02 252);
  --color-accent: oklch(52% 0.22 256);
  --color-accent-strong: oklch(43% 0.2 256);
  --color-accent-soft: oklch(94% 0.035 252);
  --color-accent-ink: oklch(98.5% 0.004 250);
  --color-focus: var(--color-ink);
  --color-graphite: oklch(19% 0.018 260);
  --color-graphite-2: oklch(24% 0.022 260);
  --color-graphite-rule: oklch(36% 0.025 258);
  --color-on-dark: oklch(95% 0.008 250);
  --color-on-dark-muted: oklch(76% 0.018 252);
  --color-focus-dark: var(--color-on-dark);
  --color-error: oklch(53% 0.2 25);
  --color-error-soft: oklch(95% 0.025 25);
  --color-success: oklch(43% 0.12 150);
  --color-success-soft: oklch(95% 0.025 150);
  --color-backdrop: oklch(14% 0.018 260 / 0.62);
  --color-shadow: oklch(18% 0.02 258 / 0.12);

  --font-display: "Space Grotesk Variable", "Space Grotesk", ui-sans-serif, sans-serif;
  --font-body: "Inter Variable", "Inter", ui-sans-serif, sans-serif;
  --font-mono: "JetBrains Mono Variable", "JetBrains Mono", ui-monospace, monospace;

  --space-3xs: 0.125rem;
  --space-2xs: 0.25rem;
  --space-xs: 0.5rem;
  --space-sm: 0.75rem;
  --space-md: 1rem;
  --space-lg: 1.5rem;
  --space-xl: 2.5rem;
  --space-2xl: 4rem;
  --space-3xl: 6rem;
  --space-4xl: 9rem;

  --text-xs: 0.75rem;
  --text-sm: 0.875rem;
  --text-base: 1rem;
  --text-md: 1.25rem;
  --text-lg: 1.5625rem;
  --text-xl: 1.953rem;
  --text-2xl: 2.441rem;
  --text-3xl: 3.052rem;
  --text-4xl: 3.815rem;
  --text-display: clamp(2.75rem, 7vw, 5.25rem);
  --text-display-s: clamp(2.5rem, 5.5vw, 4.25rem);

  --ease-out: cubic-bezier(0.16, 1, 0.3, 1);
  --ease-in: cubic-bezier(0.7, 0, 0.84, 0);
  --ease-in-out: cubic-bezier(0.65, 0, 0.35, 1);
  --dur-micro: 120ms;
  --dur-short: 220ms;
  --dur-long: 420ms;

  --rule-hair: 1px;
  --radius-xs: 0.25rem;
  --radius-sm: 0.375rem;
  --radius-md: 0.625rem;
  --radius-lg: 1rem;
  --radius-round: 999px;

  --page-gutter: clamp(1rem, 4vw, 4rem);
  --content-max: 76rem;
  --reading-max: 65ch;
  --control-height: 3rem;
  --z-base: 1;
  --z-raised: 10;
  --z-dropdown: 100;
  --z-sticky: 200;
  --z-modal: 400;
  --z-toast: 500;
  --z-tooltip: 600;
}
